import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom"
import { HelmetProvider } from 'react-helmet-async'
import { LanguageProvider } from "./hooks/useLanguage"
import Home from "./pages/Home"
import ContactConfirmed from "./pages/ContactConfirmed"
import './index.css';

function GtagRouteTracker() {
  const location = useLocation();
  React.useEffect(() => {
    // @ts-ignore
    if (typeof window !== 'undefined' && window.gtag) {
      // @ts-ignore
      window.gtag('config', 'AW-17497750432', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  return (
    <Router>
      <HelmetProvider>
        <LanguageProvider>
          <GtagRouteTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/en" element={<Home />} />
            <Route path="/contact-confirmed" element={<ContactConfirmed />} />
            <Route path="/en/contact-confirmed" element={<ContactConfirmed />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </LanguageProvider>
      </HelmetProvider>
    </Router>
  )
}

export default App